

























































































import {
  defineComponent,
  useRouter,
  useContext,
  computed,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { useUiState } from '~/composables/useUiState';
import { useUser } from '~/modules/customer/composables/useUser';
import { useCartView } from '~/modules/checkout/composables/useCartView';
import { useWishlistStore } from '~/modules/wishlist/store/wishlistStore';
import { SfButton } from '~/components/StorefrontUi';
import {
  IconHeart, IconShoppingCart, IconUser, IconRequestQuote,
} from '~/components/General/icons';
import { useRequestQuote } from '~/modules/request-quote/composables/useRequestQuote';
import LangSelect from '../LangSelect/LangSelect.vue';

export default defineComponent({
  components: {
    SfButton,
    LangSelect,
    IconHeart,
    IconShoppingCart,
    IconUser,
    IconRequestQuote,
  },
  props: {
    isSearchBarVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { toggleWishlistSidebar, toggleCartSidebar } = useUiState();
    const { isAuthenticated } = useUser();
    const router = useRouter();
    const { app, localePath } = useContext();
    const wishlistStore = useWishlistStore();
    const { totalItems } = useCartView();
    const { totalItems: quoteTotalItems } = useRequestQuote();

    const wishlistItemsCount = computed<number>(
      () => wishlistStore.wishlist?.items_count ?? 0,
    );

    const toggleWishlistSidebarIfAuth = () => {
      if (isAuthenticated.value) {
        toggleWishlistSidebar();
      } else {
        router.push(localePath('/authentication'));
      }
    };

    const handleAccountClick = async () => {
      if (isAuthenticated.value) {
        await router.push(app.localeRoute({ name: 'customer' }));
      } else {
        router.push(localePath('/authentication'));
      }
    };

    const handleRequestQuoteClick = async () => {
      if (isAuthenticated.value) {
        await router.push(app.localePath('request-quote'));
      } else {
        router.push(localePath('/authentication'));
      }
    };

    return {
      addBasePath,
      toggleWishlistSidebarIfAuth,
      handleAccountClick,
      handleRequestQuoteClick,
      toggleCartSidebar,
      wishlistItemsCount,
      isAuthenticated,
      totalItems,
      quoteTotalItems,
    };
  },
});
